import { h, render } from 'preact';
import Header from './header';

export default (element, data) => {
  const promoBar = document.getElementById('promo-bar');

  const renderHeader = () => {
    render(
      <Header
        promoBar={promoBar ? JSON.parse(promoBar.textContent) : {}}
        root={element}
        {...data}
      />,
      element,
    );
  };

  const init = () => {
    renderHeader();
    // v PLP > PDP scroll logic v //
    if (
      !(
        data.templateName.indexOf('collection') > -1 &&
        localStorage.getItem('tmw.previousProduct')
      ) ||
      window.Shopify.designMode
    ) {
      document.getElementById('MainContent').classList.remove('opacity-0');
      document
        .getElementById('shopify-section-header')
        .classList.remove('opacity-0');
      document
        .getElementById('shopify-section-promo-bar')
        .classList.remove('opacity-0');
    }
    localStorage.setItem(
      'tmw.previousProduct',
      data.templateName.indexOf('product') > -1,
    );
    // ^ PLP > PDP scroll logic ^ //

    document
      .querySelector('[data-section="footer"]')
      .classList.remove('opacity-0');
  };

  init();
};
